export const typeDataLink = (duration) => {
  switch (duration) {
    case "Disater":
      return "paymentVictim";
    case "Scholarship":
      return "studyPayment";
    default:
      return "otherWelfare";
  }
};
